import React, {useRef, useMemo} from 'react';
import styles from './styles.module.scss';
import JoditEditor from 'jodit-react';
import BoldIcon from '@gravity-ui/icons/svgs/bold.svg';
import ItalicIcon from '@gravity-ui/icons/svgs/italic.svg';
import UnderlineIcon from '@gravity-ui/icons/svgs/underline.svg';
import StrikethroughIcon from '@gravity-ui/icons/svgs/strikethrough.svg';
import HeadingIcon from '@gravity-ui/icons/svgs/heading.svg';
import ListUlIcon from '@gravity-ui/icons/svgs/list-ul.svg';
import ListOlIcon from '@gravity-ui/icons/svgs/list-ol.svg';
import FontIcon from '@gravity-ui/icons/svgs/font.svg';
import LinkIcon from '@gravity-ui/icons/svgs/link.svg';
import ArrowUturnCcwLeftIcon from '@gravity-ui/icons/svgs/arrow-uturn-ccw-left.svg';
import ArrowUturnCwRightIcon from '@gravity-ui/icons/svgs/arrow-uturn-cw-right.svg';
import classNames from 'classnames';

interface TextEditorProps {
  name: string;
  value: string;
  onBlur: (value: string) => void;
  isError?: boolean;
}

export const TextEditor = ({name, value, onBlur, isError}: TextEditorProps) => {
  const editor = useRef(null);

  // Настройка конфигурации редактора
  const config = useMemo(
    () => ({
      readonly: false,
      placeholder: 'Подробное описание',
      buttons: [
        {
          name: 'undo',
          tooltip: 'Отменить',
          iconURL: ArrowUturnCcwLeftIcon,
        },
        {
          name: 'redo',
          tooltip: 'Отменить',
          iconURL: ArrowUturnCwRightIcon,
        },
        '|',
        {
          name: 'bold',
          tooltip: 'Жирный текст',
          iconURL: BoldIcon,
        },
        {
          name: 'italic',
          tooltip: 'Курсивный текст',
          iconURL: ItalicIcon,
        },
        {
          name: 'underline',
          tooltip: 'Подчеркнутый текст',
          iconURL: UnderlineIcon,
        },
        {
          name: 'strikethrough',
          tooltip: 'Зачеркнутый текст',
          iconURL: StrikethroughIcon,
        },
        '|',
        {
          name: 'paragraph',
          tooltip: 'Параграф',
          iconURL: HeadingIcon,
        },
        {
          name: 'ul',
          tooltip: 'Маркированный список',
          iconURL: ListUlIcon,
        },
        {
          name: 'ol',
          tooltip: 'Нумерованный список',
          iconURL: ListOlIcon,
        },
        {
          name: 'brush',
          tooltip: 'Стиль текста',
          iconURL: FontIcon,
        },
        {
          name: 'link',
          tooltip: 'Ссылка',
          iconURL: LinkIcon,
        },
        '|',
      ],
      popup: {
        selection: [], // Отключаем всплывающую панель при выделении
        paragraph: [], // Отключаем всплывающую панель для параграфов
        link: [], // Отключаем всплывающую панель для ссылок
        hr: [], // Отключаем кнопку "Разделитель"
      },
      disablePlugins: ['inline-popup', 'mobile', 'tooltip', 'add-new-line'],
      toolbarAdaptive: false,
      width: 530,
      height: 256,
      showCharsCounter: false,
      showWordsCounter: false,
      showXPathInStatusbar: false,
      statusbar: false,
      language: 'ru',
    }),
    [],
  );

  return (
    <div
      className={classNames({
        [styles.editorError]: isError,
      })}>
      <JoditEditor
        ref={editor}
        value={value}
        config={config}
        name={name}
        onBlur={(newContent) => onBlur(newContent)}
        onChange={() => {}}
      />
    </div>
  );
};
